@use 'src/global/variables.scss' as var;
@use 'src/global/mixins/sr-only' as sr;

c-conversation {
  display: block;
  max-height: 510px;

  &:focus {
    z-index: 1;
    // Future Task Put this in scss variable // Todo Put also box-shadow in variable
    outline: 4px solid var.$focus-color;
    outline-offset: -4px;
  }

  .sr-only {
    @include sr.sr-only();
  }

  height: 100%;
  background-color: var.$message-screen-background-color;
  color: var.$primary-color;

  padding: 24px;
  overflow-y: auto;

  .stamp-container+.message-row {
    margin-top: 24px !important;
  }

  .form-container {
      margin-top: 24px !important;
  }

  .message-row {
    display: flex;
    align-items: flex-end;
    margin: 2px 0;

    &.message-row--user {
      justify-content: flex-end;
      // So that scrollIntoView keeps a margin to the top
      scroll-margin-top: 0.8rem; // Less than margin-bottom of message-row so that the box shadow of the previous bubble is not seen

      // scroll-snap-margin-top: 0.8rem; // For Safari, but still does not work, because Safari has a bug in combination with scrollIntoView: https://caniuse.com/?search=scroll-margin-top
      &:focus {
        // Firefox will display a black dotted border around the element otherwise
        outline: none;
      }

      margin: 10px 0 10px 0 !important;
    }
  }

  .message-full-row {
    margin: 10px 0 10px 0;
    width: 100% !important;
  }

  div>div>c-dropdown {
    margin-top: 0px !important;
  }

  div.buttons-container>c-dropdown {
    margin-top: -22px;
  }

  ul.no-bullets {
    list-style-type: none;
    /* Remove bullets */
    padding: 0;
    /* Remove padding */
    margin: 0;
    /* Remove margins */
  }

  .buttons-container+.stamp-container,
  .message-row+.buttons-container,
  .message-row+.stamp-container {
    margin-top: 24px !important;
  }

  .multiple-choice-link,
  .cookie-link,
  .cookie-button {
    width: 100%;
    font-size: 1em;
    padding: 1rem;
    background: var.$text-color-light;
    color: var.$primary-color;
    border: 1px solid currentColor;
    box-shadow: var.$message-screen-elements-box-shadow;
    cursor: pointer;
    margin-bottom: 1rem;

    // Firefox on Windows displays an additional border around focused elements
    &::-moz-focus-inner {
      border: 0;
    }

    &:hover,
    &:focus {
      outline: none;
      box-shadow: 0 0 0 3px var.$focus-color;
      border: 1px solid var.$focus-color;
    }
  }

  .multiple-choice-link,
  .cookie-link {
    display: block;
    box-sizing: border-box;
    text-decoration: none;
    text-align: center;
  }
}

// Todo Firefox ignores padding bottom in combination with overflow: auto / scroll
// Todo Safari scroll down is weird (react bot scrolls down fine)
